export class DateSlot {

  constructor(
    public id: number,
    public instructorId: number,
    public start: Date,
    public end: Date) {
  }
}
